// Palette from the FleetSpoke Assets UI design doc §2. Amber accent distinguishes Assets from TMS blue.
// Every colour here has a light and a dark value; adapters pick by the active colour scheme.

export interface ColorPair {
  readonly light: string;
  readonly dark: string;
}

export const palette = {
  accent: { light: '#D97A12', dark: '#F0A248' },
  accentInk: { light: '#8A4B05', dark: '#F6C07A' },
  accentSoft: { light: '#FBEAD4', dark: '#3A2A14' },
  steel: { light: '#2F4A63', dark: '#9DB6CC' },
  steelSoft: { light: '#E3EAF1', dark: '#22303D' },
  ok: { light: '#2E7D4F', dark: '#6FCF97' },
  okSoft: { light: '#DFF0E5', dark: '#1C3327' },
  warn: { light: '#B3690A', dark: '#F0B452' },
  warnSoft: { light: '#FDF0D8', dark: '#3A2D14' },
  bad: { light: '#B23A3A', dark: '#EF8A8A' },
  badSoft: { light: '#F7E0E0', dark: '#3D1F1F' },
  neutral: { light: '#7A8794', dark: '#7F8B97' },
  neutralSoft: { light: '#ECEEEA', dark: '#232C36' },
  ink: { light: '#1C2630', dark: '#E6EAEE' },
  surface: { light: '#FFFFFF', dark: '#1B222A' },
  background: { light: '#F6F7F5', dark: '#14191F' },
} as const satisfies Record<string, ColorPair>;

export type PaletteKey = keyof typeof palette;
